<template>
  <div>
    <li v-for="task in dataTask" class="list-group-item" :key="task.id">
      <div class="card">
        <div class="card-body p-1">
          <input style="font-size: smaller" v-model="task.title" />
          <textarea class="cardTextArea" style="font-size: smaller;" v-model="task.description"></textarea>
          <div class="cardFooter">
            <div class="cardFooterKanan">
              <p class="p-1" style="font-size: smaller;">{{task.user.name}}</p>
              <p class="p-1" style="font-size: smaller;">{{task.user.createdAt.slice(0,10)}}</p>
            </div>
            <div class="cardFooterKiri">
              <button v-on:click="createEditPage(task.id)" class="button-edit">E</button>
              <button v-on:click="deleteTask(task.id)" class="button-delete">D</button>
            </div>
          </div>
        </div>
      </div>
    </li>
  </div>
</template>

<script>
export default {
  props: ["task"],
  computed: {
    dataTask() {
      let result = [];
      for (let i = 0; i < this.task.length; i++) {
        result.push(this.task[i]);
      }
      return result;
    },
    
  },
  methods: {
      createEditPage(params) {
        // console.log(params, "create edit page");
        let payload = {
          id: params
        };

        this.$emit("createEditPage", payload);
        // console.log(params)
      },
      deleteTask(params) {
        let payload = {
          id: params,
        };
        this.$emit("deleteTask", payload);
// console.log('sudah di delete task')
      },
    },
};
</script>

<style>
</style>